import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import InstallPWA from './components/InstallPWA';
import VisualEffects from './components/VisualEffects';
import { ThemeProvider, ThemeToggle } from './context/ThemeContext';

// Pages
import OathPage from './pages/OathPage';
import LoginPage from './pages/LoginPage';
import ProfileSetup from './pages/ProfileSetup';
import Dashboard from './pages/Dashboard';
import SearchPage from './pages/SearchPage';
import ProfileView from './pages/ProfileView';
import MessagesPage from './pages/MessagesPage';
import PricingPage from './pages/PricingPage';
import PhotosPage from './pages/PhotosPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AdminPage from './pages/AdminPage';
import WelcomePage from './pages/WelcomePage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AISuggestionsPage from './pages/AISuggestionsPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import AccountPage from './pages/AccountPage';
import StatsPage from './pages/StatsPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import ContactPage from './pages/ContactPage';
import ReferralPage from './pages/ReferralPage';
import FavoritesPage from './pages/FavoritesPage';
import BlockedListPage from './pages/BlockedListPage';

// الصفحات العامة التي لا تدعم الوضع المظلم
const PUBLIC_PAGES = ['/', '/login', '/oath', '/forgot-password', '/reset-password', '/terms', '/privacy'];

// مكون لإدارة الوضع حسب المسار
function ThemeManager() {
  const location = useLocation();
  
  useEffect(() => {
    const isPublicPage = PUBLIC_PAGES.includes(location.pathname);
    
    if (isPublicPage) {
      // إزالة الوضع المظلم في الصفحات العامة
      document.documentElement.removeAttribute('data-theme');
    } else {
      // استعادة الوضع المحفوظ في الصفحات الداخلية
      const savedDarkMode = localStorage.getItem('darkMode');
      if (savedDarkMode === 'true') {
        document.documentElement.setAttribute('data-theme', 'dark');
      }
    }
  }, [location.pathname]);
  
  return null;
}

// زر المصباح العائم في جميع الصفحات الداخلية
function FloatingThemeToggle() {
  const location = useLocation();
  const isPublicPage = PUBLIC_PAGES.includes(location.pathname);
  
  if (isPublicPage) return null;
  
  return (
    <div style={{
      position: 'fixed',
      bottom: '80px',
      left: '20px',
      zIndex: 999,
    }}>
      <ThemeToggle />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App" dir="rtl">
        <BrowserRouter>
          <ThemeManager />
          <Routes>
            <Route path="/" element={<OathPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/profile-setup" element={<ProfileSetup />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/profile/:userId" element={<ProfileView />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/photos" element={<PhotosPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/ai-suggestions" element={<AISuggestionsPage />} />
            <Route path="/stories" element={<SuccessStoriesPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/referral" element={<ReferralPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/blocked" element={<BlockedListPage />} />
            <Route path="/payment-callback" element={<PricingPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <InstallPWA />
          <VisualEffects />
          <FloatingThemeToggle />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
